import React from "react";
import TypingIndicator from "../../common/typing-indicator/typing-indicator";
import MessageItem from "../message/message-item/message-item";

import "./message.scss";

const Message = ({ messages, chatContainerRef, isTyping }) => {
  return (
    <div className="message-display-container" ref={chatContainerRef}>
      <div className="message-list">
        {messages?.map((msg, index) => (
          <React.Fragment key={index}>
            <MessageItem message={msg} />
            {msg.buttons && (
              <div className="message-buttons">
                {msg.buttons.map((button, buttonIndex) => (
                  <button
                    key={buttonIndex}
                    onClick={() => button.onClick(index) || (() => {})}
                    className="message-button"
                    style={{
                      display: "flex",
                      margin: "5px 6px 5px 4px",
                      padding: "5px 10px",
                      borderRadius: "4px",
                      width: "71px",
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#FFFFFF",
                      background: button.color || "#B80012",
                      border: `1px solid ${button.color || "#B80012"}`,
                    }}
                    disabled={button.disable}
                  >
                    {button.label}
                  </button>
                ))}
              </div>
            )}
          </React.Fragment>
        ))}
        {isTyping && <TypingIndicator />}
      </div>
    </div>
  );
};

export default Message;
